import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function spacesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && typeof control.value === 'string') {
      const trimmedValue = control.value.trim();
      const containSpaces = /\s/.test(trimmedValue);

      if (containSpaces) {
        return { spacesFound: true };
      }
    }
    return null;
  };
}
